<template>
  <div class="topUI" v-show="isShow">
    <div class="topUI__bgContainer">
      <div class="topUI__body">
        <TopLogo></TopLogo>
        <TopConcertInfo></TopConcertInfo>
        <TopEnter
          :viewState="viewState"
          v-on:resume="resumeDraw"
          v-on:gotoEnd="gotoEnd"
        ></TopEnter>
        <TopOther></TopOther>
      </div>
      <div class="topBgTop"></div>
      <div class="topBgBottom"></div>
      <div class="topBgBottomBlack"></div>
      <div
        class="topBgImage"
        :style="{ backgroundImage: `url('${bg}')` }"
      ></div>
    </div>
    <Footer></Footer>
    <LoginTest v-if="debug" :concertId="concertId"></LoginTest>
    <div class="fontLoader">abc</div>
  </div>
</template>

<script>
import * as StoreUtil from "../../util/StoreUtil";
import TopEnter from "./top/TopEnter";
import TopOther from "./top/TopOther";
import TopConcertInfo from "./top/TopConcertInfo";
import TopLogo from "./top/TopLogo";
import Footer from "./Footer";
import LoginTest from "../../study/apitest/LoginTest";
import Storage from "../../api/Storage";
import DrawingStorage from "../../api/DrawingStorage";
import API from "../../api/API";
import { DrawEvent } from "../../events/DrawEvent";
import * as drawEventType from "../../events/DrawEventType";
import { noCache } from "../../util/Params";
import {ModalEvent, showAPIError, showDeleteMessage} from "../../modal/ModalEvent";
import * as types from "../../modal/ModalEventType";

const VIEW_STATE = {
  none: -1,
  normal: 1,
  resume: 2,
  deadline: 3,
  written: 4
};
export default {
  name: "TopUI",
  computed: {
    isShow() {
      return StoreUtil.isModeTop();
    },
    info() {
      return this.$store.state.concert.info;
    },
    concertId() {
      return this.$store.state.concert.concertId;
    },
    bg() {
      if (!this.info.last_pseudo_screen_image_url)
        return "";
      return this.info.last_pseudo_screen_image_url;
    },
    debug() {
      return this.$store.getters["config/debug"];
    },
    isDrawn() {
      return Storage.getDrawn(this.concertId);
    },
    hasTemp() {
      return DrawingStorage.hasTmpImage(this.concertId);
    },
    hasPassedDeadline() {
      return this.$store.getters["concert/hasClosed"];
    }
  },
  components: {
    TopConcertInfo,
    TopLogo,
    TopEnter,
    LoginTest,
    TopOther,
    Footer
  },
  data() {
    return {
      viewState: VIEW_STATE.none
    };
  },
  mounted() {
    console.log("[TopUI] mounted");
  },
  methods: {
    init() {
      console.log("[TopUI] init ");
    },
    initGoto() {
      console.log("[TopUI] init goto");
      if (this.hasPassedDeadline) {
        this.showDeadline();
        return;
      } else if (this.isDrawn) {
        console.log("もう描いてるのです", noCache, !noCache);
        if (!noCache) {
          this.showWritten();
          // this.gotoEnd();
        }
        return;
      } else if (this.hasTemp) {
        console.log("一時保存ありました！");
        if (DrawingStorage.hasOtherTmpImage(this.concertId)) {
          console.log(
            "ほかのconcert idの一時保存がありました。どうしましょ。消して開始。or 消さずにそのまま"
          );
        } else {
          console.log("このconcert id の一時保存でやりなおします。");
          StoreUtil.setContinueDrawing();
          this.showResume();
        }
      }
      else {
        this.showNormalEnter();
      }
    },
    async gotoEnd() {
      console.log("goto end");
      StoreUtil.showLoading();
      StoreUtil.setHasDrawn(true);
      const result = await API.getMessage()
        .catch(e => {
          if (e.toString().indexOf("404") > -1) {
            showDeleteMessage();
            ModalEvent.on(types.CLOSED, ()=>{
              Storage.removeDrawn(this.$store.state.concert.concertId);
              location.reload();
            })
          }
          else showAPIError(e.toString());
        })
        .finally(() => {
          StoreUtil.hideLoading();
        });
      if (result) {
        const data = result.data;
        StoreUtil.setAreaPos(data.x, data.y);
        StoreUtil.setCanvasScale(1.1);
        StoreUtil.setMyDrawingURL(result.data.painted_image_url);
        StoreUtil.gotoEnd();
      }
      // BANされてる
      else {
        StoreUtil.setHasDrawn(false);
      }
    },
    showNormalEnter() {
      this.viewState = VIEW_STATE.normal;
    },
    showDeadline() {
      this.viewState = VIEW_STATE.deadline;
    },
    showResume() {
      this.viewState = VIEW_STATE.resume;
    },
    showWritten() {
      this.viewState = VIEW_STATE.written;
    },
    resumeDraw() {
      StoreUtil.setCanvasScale(1.1);
      DrawEvent.emit(drawEventType.HISTORY_LOAD);
      StoreUtil.gotoDraw();
    }
  }
};
</script>

<style scoped lang="sass">
@import "../../sass/zindex"
@import "../../sass/common"
@import "../../sass/colors"
.topUI
  color: white
  //position: absolute
  //z-index: $z_top_ui
  position: relative
  width: 100%
  height: auto
.topUI__bgContainer
  position: relative

.topUI__body
  position: relative
  z-index: 30
.topBgTop
  background: url("../../assets/top/grad-top.png") left top repeat-x
  background-size: 1px 128px
  position: absolute
  top: 0
  width: 100%
  height: 128px
  z-index: 20

.topBgBottom
  position: absolute
  width: 100%
  height: 87px
  top: 322.5px
  z-index: 10
  background: url("../../assets/top/grad-bottom.png") left 0 repeat-x
  background-size: 1px 87px


.topBgImage
  position: absolute
  top: 56px

  @include fitWH()
  height: 356px
  z-index: 1
  background-repeat: no-repeat
  background-position: top center
  background-size: 1265px 356px
.topBgBottomBlack
  position: absolute
  top: 400px
  background-color: #000
  width: 100%
  height: 100px
  z-index: 2
.fontLoader
  opacity: 0
  width: 0
  height: 0
  overflow: hidden
  font-family: "arena-font2"
</style>
